import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'

export const ULTRA_AGENT_LEAD_API_PATH = '/api/v4/bit/ultra/agent-lead'

export type UltraAgentLeadParams = {
  traderCode: string
  nickName: string
  phone: string
  email: string
}

export const submitUltraAgentLead = (data: UltraAgentLeadParams): Promise<unknown | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: ULTRA_AGENT_LEAD_API_PATH,
    method: 'POST' as const,
    data,
  }

  return import.meta.server ? useServerFetch<unknown>(requestConfig) : request(requestConfig)
}
